<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/UZgxLW/tc-custom/9781467776578.jpg?1700368707849" alt="This image is the cover for the book My Clothes, Your Clothes, Alike and Different"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">My Clothes, Your Clothes, Alike and Different
      </h1>
      <p class="bookDescription body article font2">
        <p>Chloe gets to pick a special outfit for school! Should she wear her karate uniform? Her firefighter's helmet? Her bunny slippers? To decide, she talks with family and friends about clothes. Which clothes show a person's interests? Which clothes show someone belongs to a certain religion or culture? Which clothes tell about a person's job? See what Chloe comes up with for her special outfit!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lisa Bullard, Renée Kurilla
      </h2>
      
      <p class="authorDescription body article"><B>Lisa Bullard</B> is the award-winning author of more than 60 books for children, including<I> You Can Write a Story: A Story-Writing Recipe for Kids</I>. She teaches writing classes at the Loft Literary Center and regularly visits schools to talk with students about story-writing.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Lerner Publishing Group
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b6842602